<div class="px-4 sm:px-6 lg:px-8">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="font-semibold leading-6 text-gray-900 !text-3xl">Arbeitsverhältnisse</h1>
    </div>
  </div>

  <form class="grid grid-cols-2 space-y-2 pb-4 w-full gap-x-4 items-end shadow-lg p-3 rounded-md mt-4"
        name="new-employee">
    <div class="col-span-2 flex w-full">
      <span class="fw-bold">Suchen
      <span *ngIf="PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Add())">
        / Neues Arbeitsverhältnis anlegen
      </span>
      </span>
    </div>
    <div [class.col-span-2]="!PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Add())"
         class="grow">
      <label class="block text-sm font-medium leading-6 text-gray-900" for="er_name">Name</label>
      <div class="mt-1">
        <input [(ngModel)]="er_name" (ngModelChange)="Filter()" autocomplete="er_name" class="block h-10 w-full rounded-md border-2 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-900 sm:text-sm sm:leading-6" id="er_name"
               name="er_name"
               type="text">
      </div>
    </div>
    <div *ngIf="PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Add())"
         class="grow col-start-2">
      <label class="block text-sm font-medium leading-6 text-gray-900" for="er_salary">Stundenlohn</label>
      <div class="mt-1 relative">
        <div class="w-12 absolute flex rounded-l-md border-r-2 inset-y-2">
          <span class="m-auto text-gray-600">&euro;&nbsp;/&nbsp;h</span>
        </div>
        <input [(ngModel)]="er_salary" autocomplete="er_salary" class="block !pl-14 h-10 w-full rounded-md border-2 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-900 sm:text-sm sm:leading-6" id="er_salary" name="er_salary"
               step="0.01"
               type="number">
      </div>
    </div>
    <div [class.col-span-2]="!PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Add())"
         class="grow">
      <label class="block text-sm font-medium leading-6 text-gray-900" for="er_multiplier">Multiplier</label>
      <div class="mt-1">
        <input [(ngModel)]="er_multiplier" autocomplete="er_multiplier" class="block h-10 w-full rounded-md border-2 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" id="er_multiplier"
               name="er_multiplier"
               type="number">
      </div>
    </div>
    <div *ngIf="PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Add())"
         class="grow col-start-2">
      <label class="block text-sm font-medium leading-6 text-gray-900" for="er_limit">Limit</label>
      <div class="mt-1 relative">
        <div class="w-12 absolute flex rounded-l-md border-r-2 inset-y-2">
          <span class="m-auto text-gray-600">&euro;</span>
        </div>
        <input [(ngModel)]="er_limit" autocomplete="er_limit" class="block !pl-14 h-10 w-full rounded-md border-2 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-900 sm:text-sm sm:leading-6" id="er_limit" name="er_limit" step="0.01"
               type="number">
      </div>
    </div>
    <div *ngIf="PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Add())"
         class="col-span-2 shrink">
      <label class="block text-sm font-medium leading-6 text-gray-900 sr-only" for="submit"></label>
      <div class="mt-2">
        <input (click)="Add()" autocomplete="family-name" class="px-4 block h-10 w-full rounded-md border-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-900 sm:text-sm sm:leading-6" id="submit" name="submit" type="submit"
               value="Abschicken">
      </div>
    </div>
  </form>

  <app-loading *ngIf="!relationships_filtered" class="mt-4"></app-loading>

  <div *ngIf="relationships_filtered && relationships_filtered.length > 0" class="mt-4 flex flex-col w-full">
    <div>
      <!-- "Bearbeiten" enters the select-for-export mode (checkboxes + date range + download). The payroll
           accountant needs it too — the export is their core deliverable — so it is NOT hidden for payroll. The
           only admin-only action (the per-row edit/delete link) lives outside this mode and stays gated below. -->
      <span (click)="enterSelectionMode()"
            *ngIf="!selectionMode"
            class="font-bold cursor-pointer text-theme-primary-700 hover:text-theme-primary-900 select-none">Bearbeiten</span>
      <div *ngIf="selectionMode" class="inline-flex space-x-2">
        <a
          (click)="leaveSelectionMode()"
          class="font-bold select-none place-self-center text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer">Fertig</a>
        <!-- Backend grants Payroll the Zeiten download, so enable it for a payroll session as well as admins. -->
        @if (PermissionService.CheckPermission(PermissionService.Document_EmploymentRelationship_Download()) || PermissionService.IsPayroll()) {
          <!-- Offered only for a real range: before the company zone answers both dates are empty (#648 review). -->
          @if (canExport) {
            <app-download
              Text="Zeiten exportieren" [Data]="downloadData" data-testid="payroll-export"
              [DownloadInformation]="downloadInformation" [OverrideTextSize]="false" [Params]="downloadParams"
              [Route]="ServerEndpoints.Document_EmploymentRelationship_Download"
              class="place-self-center ml-auto select-none"></app-download>
          } @else {
            <span aria-disabled="true" data-testid="payroll-export-unavailable"
                  class="place-self-center ml-auto select-none cursor-not-allowed text-gray-500">Zeiten exportieren</span>
          }
        }
      </div>
    </div>
    <div *ngIf="selectionMode" class="grid grid-cols-2 bg-white rounded-lg p-2 shadow-lg mt-2 gap-x-3">
      <input (ngModelChange)="setDate($event, Side.Left)" [class.text-red-600]="!areValidDates()" [ngModel]="getDate(Side.Left)"
             aria-label="Export-Zeitraum Von" data-testid="payroll-range-from" type="date">
      <input (ngModelChange)="setDate($event, Side.Right)" [class.text-red-600]="!areValidDates()" [ngModel]="getDate(Side.Right)"
             aria-label="Export-Zeitraum Bis" data-testid="payroll-range-to" type="date">
    </div>
  </div>

  <div *ngIf="relationships_filtered" class="mt-4 rounded-md shadow-lg p-3">
    <span *ngIf="relationships_filtered.length == 0">Keine Einträge vorhanden.</span>

    <ul class="divide-y divide-gray-100" role="list">
      <li *ngFor="let relationship of relationships_filtered"
          class="relative flex flex-wrap items-center justify-between gap-x-6 gap-y-4 py-2 sm:flex-nowrap">
        <div>
          <p class="text-sm font-semibold leading-6 text-gray-900">
            <a [queryParams]="{'employmentRelationship': relationship.id}" [routerLink]="['/' + Routes.CompanyEmployee]"
               class="hover:underline text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer">{{ relationship.name }}</a>
          </p>
          <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
            <p>
              <span class="">{{ relationship.salary | currency: "EUR" }} / Stunde</span>
            </p>
            <svg class="h-0.5 w-0.5 fill-current" viewBox="0 0 2 2">
              <circle cx="1" cy="1" r="1"/>
            </svg>
            <p>
              <span *ngIf="relationship.limit != undefined">Grenze: {{ relationship.limit | currency: "EUR" }}</span>
              <span *ngIf="relationship.limit == undefined">Ohne Begrenzung</span>
            </p>
          </div>
        </div>
        <dl class="flex w-full flex-none justify-between gap-x-8 sm:w-auto">
          <div class="flex w-16 gap-x-2.5">
            <dt>
              <span class="sr-only">Total employees</span>
              <svg class="bi bi-person" height="24" viewBox="0 0 16 16" width="24"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"/>
              </svg>
            </dt>
            <dd class="text-sm leading-6 text-gray-900">{{ relationship.employees.length }}</dd>
          </div>
          <div>
            <input *ngIf="selectionMode" [ngModel]="relationship.selected" class="" type="checkbox">
            <a
              (click)="redirectToSettings(relationship.id)"
              *ngIf="!selectionMode && PermissionService.CheckPermission(PermissionService.Company_EmploymentRelationship_Get())"
              class="select-none text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer inline-flex">
              <svg class="bi bi-trash3" height="20" viewBox="0 0 16 16" width="20"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
              </svg>
            </a>
          </div>
        </dl>
        <div (click)="relationship.selected = !relationship.selected;setDownloadData()"
             *ngIf="selectionMode" [class.!bg-theme-primary-300]="relationship.selected"
             class="absolute -inset-x-4 inset-y-0 cursor-pointer bg-transparent opacity-25">
        </div>
      </li>
    </ul>
  </div>
</div>
